export function normalize(data, byField, func = (data) => data) {
  return Object.reduce((obj, val) => Object.assign({
    [val[byField]]: func(val)
  }), {})
}

export function omitIf(data, condition) {
  const copy = {}
  for (let key in data) {
    if (!condition(data[key])) {
      copy[key] = data[key]
    }
  }
  return copy
}

export function debounce(f, delay=80) {
  let timeout = null
  return function (...args) {
    if (timeout !== null) {
      clearTimeout(timeout)
    }
      timeout = setTimeout(f.bind(this, ...args), delay)
  }
}

export function prob2sigma(x) {
  if (x === 1.0) return x * 100
  let z = 0
  const lim = 4.53988e-5
  const a = 0.2
  z = x < lim ? lim : x > 1.0 ? 1.0 : x
  let zz = 50.0 - (1.0 / a) * Math.log(1.0 / z - 1.0)
  if (zz < 0.000102575) zz = 0
  if (zz > 100.0) zz = 100.0
  return zz
}

export function sigma2prob(zz) {
  const a = 0.2
  const z = 1.0 / (Math.exp((50.0 - zz) * a) + 1)
  return z
}

export function rgbhash(string) {
  // see https://gist.github.com/0x263b/2bdd90886c2036a1ad5bcf06d6e6fb37
  let hash = 0
  if (string.length === 0) return hash
  for (var i = 0; i < string.length; i++) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash)
    hash = hash & hash
  }
  const rgb = [0, 0, 0]
  for (var i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 255
    rgb[i] = value
  }

  return rgb
}


const intoPairs = xs => xs.slice(1).map((x, i) => [xs[i], x])
const breakAt = (places, str) => intoPairs([0, ...places, str.length]).map(
  ([a, b]) => str.substring(a, b)
)
export const breakWhere = (words, str) => breakAt(
  words.slice(0).sort(({offset: o1}, {offset: o2}) => o1 - o2).reduce(
    (a, {offset, length}) => [...a, offset, offset + length],
    []
  ),
  str
)
